(() => {
  const swiperSelector = '.swiper-upsell[js-cart-upsell-slider]';

  const initSwiper = (el) => {
    if (!window.Swiper || el.classList.contains('swiper-initialized')) return;

    const container = el.closest('[data-upsell-slider-root]') || document;
    const nextBtn = container.querySelector('.swiper-button-next');
    const prevBtn = container.querySelector('.swiper-button-prev');

    new Swiper(el, {
      slidesPerView: 3.3,
      spaceBetween: 12,
      mousewheel: { forceToAxis: true },
      direction: 'horizontal',
      observer: true,
      observeParents: true,          
      breakpoints: {
        0: {
          slidesPerView: 2.160,
        },
        768: {
          slidesPerView: 2.950,
        }
      }
    });
  };

  const scan = () => {
    document.querySelectorAll(swiperSelector).forEach(initSwiper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const observer = new MutationObserver(() => {
    scan();
  });

  observer.observe(document.body, { childList: true, subtree: true }); 

  // Re-init after cart updates (e.g., drawer re-render)
  document.addEventListener('cart:update', () => {
    // Delay to allow DOM replacement to finish
    setTimeout(scan, 0);
  });
})();
